import * as React from 'react'
import { Main as MainLayout } from 'layouts/index'
import ReturnPolicy from 'sections/ReturnPolicy'
import { trackReturnPolicyPageVisit } from 'events/index'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'

export default class ReturnPolicyPage extends React.Component {
	componentDidMount() {
		trackReturnPolicyPageVisit()
	}
	public render() {
		return (
			<MainLayout>
				<ReturnPolicy />
				<ScrollSequenceStatic />
			</MainLayout>
		)
	}
}
